<template>
  <select-artist
    :is-shown="isShown"
    :selected-ids="selectedIds"
    modal-name="selectRoleAssignmentArtist"
    modal-class="select-role-assignment-artist-modal"
    title="役割設定するアーティストを選択"
    :artist-type="1"
    :kana-optional="true"
    @close="onClose"
    @select="onSelect" />
</template>

<script>
import SelectArtist from './SelectArtist'

export default {
  name: 'SelectRoleAssignmentArtist',
  components: { SelectArtist },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onSelect(artists) {
      this.$emit('select', artists)
    },
  },
}
</script>
